import {round} from "lodash";
import * as THREE from "three";
import styles from "./index.module.scss";

// the only characters the user is allowed to enter for numeric input fields
const decimalChars = '.-0123456789';
const allowedKeys = ['ArrowLeft', 'ArrowRight', 'Backspace'];

const DirectionInput = ({name, value, transformOnChange, is2D, onFocus, onBlur, depth}) => {
  let {x, y, z} = value;

  return (
    <div className={`${styles.container} ${depth === 1 ? styles.depth_1 : ""}`}>
      <p className={styles.title}>{name}</p>
      <div className={styles.inputs_container}>
        <div className={styles.input_container}>
          <p>X</p>
          <input
            step="0.1"
            name={name + "-x"}
            value={name === "Rotation" ? getDegree(x) : x}
            onChange={transformOnChange}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={e => {
              if (!(decimalChars.includes(e.key)) && !(allowedKeys.includes(e.key))) {
                e.preventDefault();
              }
            }}    
          />
        </div>
        <div className={styles.input_container}>
          <p>Y</p>
          <input
            step="0.1"
            name={name + "-y"}
            value={name === "Rotation" ? getDegree(y) : y}
            onChange={transformOnChange}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={e => {
              if (!(decimalChars.includes(e.key)) && !(allowedKeys.includes(e.key))) {
                e.preventDefault();
              }
            }}    
          />
        </div>
        {!is2D && (
          <div className={styles.input_container}>
            <p>Z</p>
            <input
              step="0.1"
              name={name + "-z"}
              value={name === "Rotation" ? getDegree(z) : z}
              onChange={transformOnChange}
              onFocus={onFocus}
              onBlur={onBlur}
              onKeyDown={e => {
                if (!(decimalChars.includes(e.key)) && !(allowedKeys.includes(e.key))) {
                  e.preventDefault();
                }
              }}    
            />
          </div>
        )}
      </div>
    </div>
  );
};

const getDegree = rad => {
  return typeof rad === "string" ? rad : round(rad * THREE.MathUtils.RAD2DEG);
};

export default DirectionInput;
